import { useCallback, useRef, useState } from 'react';

const useDragAndDrop = (handleDrop: (files: FileList) => void) => {
	const [isDragging, setIsDragging] = useState(false);

	const dragCounterRef = useRef<number>();

	const onDragOver = useCallback((event: React.DragEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
	}, []);

	const onDragEnter = useCallback((event: React.DragEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
		dragCounterRef.current!++;
		if (event.dataTransfer?.items && event.dataTransfer.items.length > 0) setIsDragging(true);
	}, []);

	const onDragLeave = useCallback((event: React.DragEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
		dragCounterRef.current!--;
		if (dragCounterRef.current === 0) setIsDragging(false);
	}, []);

	const onDrop = useCallback((event: React.DragEvent<HTMLElement>) => {
		event.preventDefault();
		event.stopPropagation();
		setIsDragging(false);
		if (event.dataTransfer?.files && event.dataTransfer.files.length > 0) {
			handleDrop(event.dataTransfer.files);
			event.dataTransfer.clearData();
			dragCounterRef.current = 0;
		}
	}, [handleDrop]);

	return { isDragging, onDragOver, onDragEnter, onDragLeave, onDrop };
}

export default useDragAndDrop;